import gql from 'graphql-tag';

import {
    PRODUCT_ARRANGEMENT_FRAGMENT,
    PRODUCT_ARRANGEMENT_WITH_PRODUCTS_FRAGMENT,
} from '../fragments/productArrangement';

/**
 * Juste de quoi remplir un select. `GET_PRODUCT_ARRANGEMENTS` embarque `productIdsWithStockMax`, soit
 * des milliers de lignes — inutile pour lister des noms dans un filtre.
 */
export const GET_PRODUCT_ARRANGEMENTS_FOR_SELECT_QUERY = gql`
    query GET_PRODUCT_ARRANGEMENTS_FOR_SELECT {
        productArrangementsQuery {
            _id
            name
        }
    }
`;

export const GET_PRODUCT_ARRANGEMENTS_QUERY = gql`
    query GET_PRODUCT_ARRANGEMENTS {
        productArrangementsQuery {
            ...ProductArrangementFragment
        }
    }
    ${PRODUCT_ARRANGEMENT_FRAGMENT}
`;

export const GET_PRODUCT_ARRANGEMENT_QUERY = gql`
    query GET_PRODUCT_ARRANGEMENT($productArrangementId: String!) {
        productArrangementQuery(productArrangementId: $productArrangementId) {
            ...ProductArrangementWithProductsFragment
        }
    }
    ${PRODUCT_ARRANGEMENT_WITH_PRODUCTS_FRAGMENT}
`;
